import { create } from 'zustand';
import { HealthPlan } from '../../../models/HelthPlan';

interface IModel {
  healthPlan: HealthPlan;
  setHealthPlan: (props: HealthPlan) => void;
}

export const useHealthPlan = create<IModel>(set => ({
  healthPlan: {} as HealthPlan,
  setHealthPlan: healthPlan => set(() => ({ healthPlan }))
}));
